import type { PricingBasis } from '@/types'
import { currencyLocale, formatCurrency, formatEur } from '@/utils/formatCurrency'

// Whether the viewer is shown net prices: an account on the net basis, and an
// organization on the gross basis, which pays the VAT on top.
export function showsNet(basis: PricingBasis | undefined, isOrganization: boolean): boolean {
  return basis === 'net' || isOrganization
}

// A gross catalogue price in cents as the viewer is shown it.
export function shownGross(grossCents: number, taxRate: number, net: boolean): number {
  return net && taxRate > 0 ? Math.round(grossCents / (1 + taxRate)) : grossCents
}

// An amount the backend quotes on the account's basis, as the viewer is shown
// it: only an organization on the gross basis is shown less, its net.
export function shownOnBasis(cents: number, basis: PricingBasis, isOrganization: boolean, taxRate: number): number {
  return basis === 'gross' ? shownGross(cents, taxRate, isOrganization) : cents
}

// Net metered amounts in cents as the viewer is shown them: with VAT unless
// the viewer is shown net. rate keeps five places, so a gross rate such as
// 1,785 ct reads exactly as charged; money rounds to the cent.
export function netRateFormat(net: boolean, taxRate: number, locale: string) {
  const shown = (cents: number) => (net ? cents : cents * (1 + taxRate))
  return {
    shown,
    rate: (cents: number) => formatCurrency(shown(cents) / 100, 'EUR', currencyLocale(locale), 5),
    money: (cents: number) => formatEur(Math.round(shown(cents)) / 100, locale)
  }
}
